<template lang="html">
  <form role="form" @submit.prevent.stop>
    <autosplit-dialog-modal ref="autosplitModal"></autosplit-dialog-modal>
    <payout-form-group :label="$t('Номер карты')" :required="true" :has-errors="model.errors.has('cardNumber')">
      <filtered-input-wrapper v-model="model.values.cardNumber">
        <payout-cardnumber-input v-model="model.values.cardNumber"></payout-cardnumber-input>
      </filtered-input-wrapper>
      <payout-input-hint-block v-slot:hints :hint="$t('card_number_hint')"></payout-input-hint-block>
      <error-message-block v-slot:errors attribute="cardNumber|*" :errors="model.errors"></error-message-block>
    </payout-form-group>
    <payout-textfield-input-group :model="model" :label="$t('Назначение')" :required="true" attribute="description"></payout-textfield-input-group>
    <payout-input-amount-form-group :model="model" :hint="$t('amount_hint')"></payout-input-amount-form-group>
    <payout-evaluate-fee-form-group :model="model"></payout-evaluate-fee-form-group>
    <!-- Будет применен курс автоконвертации ({src} = {dest})-->
    <payout-destination-currency-conversion-notice-form-group :model="model"></payout-destination-currency-conversion-notice-form-group>
    <!-- Ожидаемая сумма зачисления-->
    <payout-estimated-destination-amount-form-group :model="model"></payout-estimated-destination-amount-form-group>
    <template v-if="model.options.limitsAlertHtml">
      <payout-toggable-hint-panel-form-group :heading="$t('Лимиты')" :link-text="$t('Информация о лимитах')">
        <div v-html="model.options.limitsAlertHtml"></div>
      </payout-toggable-hint-panel-form-group>
    </template>
    <payout-form-notification-block :model="model"></payout-form-notification-block>
    <hr/>
    <payout-group-verification-type :model="model"></payout-group-verification-type>
  </form>
</template>

<script lang="ts">
import {defineComponent, reactive} from "vue";
import {UkrainianCardsPaymentModel} from "@/components/forms/payout/forms/cards/cards-payments";
import AutosplitDialogModal from "@/views/pages/finance/payout/AutosplitDialogModal.vue";
import PayoutFormGroup from "@/components/forms/payout/PayoutFormGroup.vue";
import FilteredInputWrapper from "@/components/forms/payout/forms/inputs/FilteredInputWrapper.vue";
import PayoutCardnumberInput from "@/components/forms/payout/forms/PayoutCardnumberInput.vue";
import PayoutInputHintBlock from "@/components/forms/payout/PayoutInputHintBlock.vue";
import ErrorMessageBlock from "@/components/forms/payout/ErrorMessageBlock.vue";
import PayoutTextfieldInputGroup from "@/components/forms/payout/PayoutTextfieldInputGroup.vue";
import PayoutInputAmountFormGroup from "@/components/forms/payout/PayoutInputAmountFormGroup.vue";
import PayoutEvaluateFeeFormGroup from "@/components/forms/payout/PayoutEvaluateFeeFormGroup.vue";
import PayoutEstimatedDestinationAmountFormGroup
  from "@/components/forms/payout/forms/PayoutEstimatedDestinationAmountFormGroup.vue";
import PayoutFormNotificationBlock
  from "@/components/forms/payout/forms/PayoutFormNotificationBlock.vue";
import PayoutGroupVerificationType
  from "@/components/payout/verification/PayoutGroupVerificationType.vue";
import PayoutToggableHintPanelFormGroup
  from "@/components/forms/payout/hint/PayoutToggableHintPanelFormGroup.vue";
import AbstractPayoutForm from "@/components/forms/payout/abstract/AbstractPayoutForm.vue";
import PayoutDestinationCurrencyConversionNoticeFormGroup
  from "@/components/forms/payout/crypto/PayoutDestinationCurrencyConversionNoticeFormGroup.vue";

export default defineComponent({
  name: "UkrainianCardsPaymentForm",
  extends: AbstractPayoutForm,
  components: {
    PayoutDestinationCurrencyConversionNoticeFormGroup,
    PayoutToggableHintPanelFormGroup,
    PayoutGroupVerificationType,
    PayoutFormNotificationBlock,
    PayoutEstimatedDestinationAmountFormGroup,
    PayoutEvaluateFeeFormGroup,
    PayoutInputAmountFormGroup,
    PayoutTextfieldInputGroup,
    ErrorMessageBlock,
    PayoutInputHintBlock,
    PayoutCardnumberInput, FilteredInputWrapper, PayoutFormGroup, AutosplitDialogModal},
  setup() {
    const model = reactive(new UkrainianCardsPaymentModel());
    return {
      model
    };
  },
})
</script>

<style scoped>

</style>

<i18n>
{
  "ru": {
    "Номер карты": "Номер карты",
    "card_number_hint": "Номер карты получателя. Пример: 1234 5678 9012 3456",
    "amount_hint": "Конвертация в UAH происходит на базе курса USD/UAH. В случае оформления платежа с кошелька отличного от USD будет произведена предварительная конвертация в USD. Зачисление средств происходит с карты физического лица."
  },
  "en": {
    "Лимиты": "Limits",
    "Информация о лимитах": "Information about limits",
    "Назначение": "Description",
    "amount_hint": "Conversion to UAH is based on the USD/UAH exchange rate. In case of making a payment from a wallet other than USD, a preliminary conversion into USD will be made. Funds are credited from the card of an individual.",
    "Номер карты": "Card number",
    "card_number_hint": "Card number of the recipient. Example: 1234 5678 9012 3456"
  }
}
</i18n>
